import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { HelperService } from '../services/helper.service';
import { GeneralStoreService } from '../store/general.store';

@Injectable({
  providedIn: 'root'
})

export class RedirectGuard implements CanActivate {

  constructor(
    private router: Router,
    private generalStoreService: GeneralStoreService,
    private helperService: HelperService,
  ) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {

    const user = this.generalStoreService.getUserValue();
    const token = this.generalStoreService.getTokenValue();
    if (token && user) {
      await this.helperService.getMenu();
      let userLandingPageUrl = await this.helperService.getUserLandingPageUrl();
      this.router.navigate([userLandingPageUrl]);
      return false;
    }

    return true;
  }
}
